<div class="clipboard-input-container chromeclient-none-float">
   <textarea readonly id="clipboard-input" (copy)="clipboardCopy($event)" (paste)="clipboardPaste($event)"></textarea>
</div>